export default {
  pageTitle: 'Muffle Fabrication',
  metaDescription: 'TEF fabricates industrial muffles and furnace components in high-temperature resistant alloys for thermal processing applications.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  product: {
    name: 'Muffle',
    desc: 'The following is a catalog of our experience in Muffle fabrication in various types of materials, types and specifications.',
  },
};
